import { useQuery } from '@tanstack/react-query';
import { getForecast, getForecastDates } from '../api/client';

export function useForecastDates() {
  return useQuery({
    queryKey: ['forecast-dates'],
    queryFn: getForecastDates,
    staleTime: 5 * 60 * 1000, // 5 minutes — the daily report changes at most once/day
  });
}

export function useForecast(date: string | undefined) {
  return useQuery({
    queryKey: ['forecast', date],
    queryFn: () => getForecast(date as string),
    enabled: !!date,
    staleTime: 60 * 1000,
  });
}
